import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "currentColor",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M46.7 34c.7 0 1.3-.6 1.3-1.3V15.3c0-2.2-1.8-4-4-4H4c-.5 0-.9.1-1.3.2V10c0-.7.6-1.3 1.3-1.3h33.3c.7 0 1.3-.6 1.3-1.3S38.1 6 37.3 6H4c-2.2 0-4 1.8-4 4v28.2c.3 2 1.8 3.5 3.8 3.8H44c2.2-.1 3.9-1.8 3.9-3.9 0-.7-.5-1.4-1.3-1.4-.7 0-1.4.5-1.4 1.3 0 .7-.6 1.4-1.3 1.4h-5.3V34h8.1zM28 31.3c-3.2 0-4.7-2.3-4.7-4.7 0-1.2.4-2.4 1.2-3.2.8-.9 2-1.4 3.5-1.4h17.3v9.3H28zm17.3-16v4h-6.7V14H44c.7 0 1.3.6 1.3 1.3zm-9.3 24H4.1c-.7-.1-1.3-.7-1.4-1.4V15.3c0-.7.6-1.3 1.3-1.3h32v5.3h-8c-2.2 0-4.1.8-5.5 2.3-1.2 1.3-1.8 3.1-1.8 5 0 3.6 2.5 7.3 7.3 7.3h8v5.4z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "29.3",
      cy: "26.7",
      r: "2"
    })]
  })
});